import React from 'react';
import T from "i18n-react/dist/i18n-react";
import { Row, Col, Card } from 'elemental-react16';
import '../../node_modules/elemental-react16/less/elemental.less';

const Checkout = (props) =>{
    return(
        <Card className="checkout-modal">
            <Row>
                <Col xs="100%" sm="1/3" lg="1/3" style={{textAlign: 'center', position: 'relative', margin: '0px 0px 45px'}}>
                    <div className="checkout-icons">
                        <i className="fas fa-shopping-basket" />
                        <i className="far fa-check-circle" />
                    </div>
                </Col>
                <Col xs="100%" sm="2/3" lg="2/3">
                    <h1>CHECKOUT</h1>
                    <h4 style={{lineHeight: 1.5}}>{T.translate("labels.requestOfPaying1")}<hr/>{T.translate("labels.requestOfPaying2")}</h4>
                    <hr/>
                    <h2>{T.translate("labels.orderID")}: <b>{props.userSessionId}</b></h2>
                </Col>
            </Row>
        </Card>
    )
};

export default Checkout;


// WEBPACK FOOTER //
// ./src/components/Checkout.js